import { useState, useEffect } from "react";
import {
  Box,
  CircularProgress,
  Tooltip,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GridColDef } from "@mui/x-data-grid";
import { BuildingDoorListModal } from "./BuildingDoorListModal";
import { getJwtTokenFromIdToken } from "../auth/AuthFanc";
import UpdateButton from "../../atoms/Button/UpdateButton";
import {
  CustomContainer,
  StyledDataGrid,
  customDataGridLocaleTextAll,
  customDataGridLocaleTextLoading,
  customDataGridLocaleTextNoData,
} from "../../../styles/styles";
import IconButtonWithTooltip from "../../atoms/Button/IconButtonWithTooltip";
import EditIcon from "@mui/icons-material/Edit";
import DoorSlidingIcon from "@mui/icons-material/DoorSliding";

interface Building {
  autoBuildingId: number;
  buildingId: string;
  buildingManagementId: string;
  buildingName: string;
  buildingAddress: string;
  memo: string;
  isEnabled: boolean;
}

const BuildingListPage = () => {
  const navigate = useNavigate();

  // useStateフックの初期値を空の配列に設定
  const [data, setData] = useState<Building[]>([]);

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | undefined>(undefined);

  // useEffectフック内のロジックを修正
  useEffect(() => {
    const fetchData = async () => {
      // JWTトークンを取得します
      const jwtToken = await getJwtTokenFromIdToken();
      try {
        // call indexBuildings API
        const response = await fetch(
          process.env.REACT_APP_API_ENDPOINT + "/buildings",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: jwtToken,
            },
          },
        );
        const jsonData = await response.json();
        // レスポンスが正常であればjsonData.buildingsをsetDataで設定し、
        // エラーが発生した場合は空の配列をsetDataで設定
        setData(jsonData.buildings || []);
        setIsLoading(false);
      } catch (error: any) {
        setError(error);
        setIsLoading(false);
        // エラーが発生したときも空の配列をsetDataで設定
        setData([]);
      }
    };

    fetchData();
  }, []);

  const handleEditBuildingClick = (autoBuildingId: number) => {
    // navigate(`/buildings/${buildingId}/edit`);
    navigate(`/buildings/` + autoBuildingId);
    console.log(
      `物件編集 button clicked 選択された物件: ${autoBuildingId}`,
    );
  };

  const [openBuildingModal, setOpenBuildingModal] = useState(false);
  const [autoBuildingId, setAutoBuildingId] = useState<number>(2); //テストで２を入れてる

  const handleOpenModal = (buildingId: number) => {
    setAutoBuildingId(buildingId);
    setOpenBuildingModal(true);
  };

  if (isLoading) {
    <Box display="flex" justifyContent="center" alignItems="center">
      <CircularProgress /> {/* MUIの CircularProgress コンポーネント */}
    </Box>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const columns: GridColDef[] = [
    // { field: "isEnabled", headerName: "状態", flex: 0.5, valueGetter: (params: any) => params.row.isEnabled ? "有効" : "無効", renderCell: (params) => (<Tooltip title={params.value}><span>{params.value}</span></Tooltip>) },
    {
      field: "buildingId",
      headerName: "物件システムID",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "buildingManagementId",
      headerName: "取付先コード（物件管理ID）",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "buildingName",
      headerName: "取付先名（物件名称）",
      flex: 2,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "buildingAddress",
      headerName: "物件住所",
      flex: 3,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "memo",
      headerName: "メモ",
      flex: 3,
      valueGetter: () => "メモ",
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "autoBuildingId",
      headerName: "操作",
      flex: 2,
      renderCell: (params: any) => (
        <>
          <IconButtonWithTooltip
            title="編集"
            onClick={() => handleEditBuildingClick(params.row.autoBuildingId)}
            icon={<EditIcon />}
          />
          <IconButtonWithTooltip
            title="ドア一覧"
            onClick={() => handleOpenModal(params.row.autoBuildingId)}
            icon={<DoorSlidingIcon />}
          />
        </>
      ),
    },
  ];
  return (
    <CustomContainer maxWidth={false}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="flex-start"
        marginBottom={2}
      >
        <Typography variant="h5" component="h2" gutterBottom>
          管理物件一覧
        </Typography>
        <Box display="flex" width="100%" justifyContent="flex-end">
          <UpdateButton />
        </Box>
      </Box>
      <div style={{ height: 700, width: "100%" }}>
        {" "}
        {/* width: '100%' を追加 */}
        <StyledDataGrid
          rows={data}
          columns={columns}
          getRowId={(row) => row.autoBuildingId}
          disableRowSelectionOnClick
          localeText={
            isLoading
              ? customDataGridLocaleTextLoading
              : data.length === 0
                ? customDataGridLocaleTextNoData
                : customDataGridLocaleTextAll
          }
        />
      </div>

      <BuildingDoorListModal
        openBuildingModal={openBuildingModal}
        setOpenBuildingModal={setOpenBuildingModal}
        autoBuildingId={autoBuildingId}
      />
    </CustomContainer>
  );
};

export default BuildingListPage;
